import helpers from './helpers';

function addLiveLoad() {
  if (window.location.origin == 'http://localhost:3001') {
    helpers.addScript('http://localhost:35729/livereload.js');
  }
}

function toTop() {
  if (toTopEl) {
    toTopEl.addEventListener('click', function(e) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}

function headerSticky() {
  if (headerEl) {
    if (window.pageYOffset > 90) {
      headerEl.classList.add('sticky');
    } else {
      headerEl.classList.remove('sticky');
    }
  }
}

function nav() {
  let navEl = document.getElementById('jsNav'),
    navBtnEl = document.getElementById('jsNavBtn');
  if (navBtnEl) {
    navBtnEl.addEventListener('click', function() {
      if (navBtnEl.classList.contains('active')) {
        navBtnEl.classList.remove('active');
        navEl.classList.remove('show');
      } else {
        navBtnEl.classList.add('active');
        navEl.classList.add('show');
      }
    });
  }
}

function expandNav() {
  let expandEls = document.querySelectorAll('.jsExpand');
  if (expandEls.length > 0) {
    expandEls.forEach(expandEl => {
      expandEl.addEventListener('click', function(e) {
        if (expandEl.classList.contains('show')) {
          expandEl.classList.remove('show');
          expandEl.parentElement.classList.remove('show');
        } else {
          expandEl.classList.add('show');
          expandEl.parentElement.classList.add('show');
        }
      });

    });
  }
}

function anchorMove(id) {
  let el = document.getElementById(id);
  if (el) {
    window.scrollTo({
      top: el.offsetTop - 70,
      behavior: 'smooth'
    });
  }
}

function anchor() {
  let anchorEls = document.querySelectorAll('.jsAnchor');
  if (anchorEls.length > 0) {
    anchorEls.forEach(anchorEl => {
      anchorEl.addEventListener('click', function() {
        if (anchorEl.classList.contains('current')) {
          anchorEl.classList.remove('current');
        } else {
          helpers.removeCurrentClass(anchorEls);
          anchorEl.classList.add('current');
          anchorMove(anchorEl.dataset.anchor);
        }
      });
    });
  }
}

function navAnchor() {
  let anchorNavEls = document.querySelectorAll('.jsNavAnchor');
  if (anchorNavEls.length > 0) {
    anchorNavEls.forEach(anchorNavEl => {
      anchorNavEl.addEventListener('click', function(e) {
        if (anchorNavEl.href.search(window.location.pathname.substring(1)) > 0) {
          e.preventDefault();
          anchorMove(anchorNavEl.dataset.anchor);
        }
      });
    });
  }
}

function anchorHash() {
  let hash = window.location.hash.substring(1);
  if (hash) {
    let el = document.getElementById(hash);
    if (el) {
      window.scrollTo({
        top: el.offsetTop - 70,
        behavior: 'smooth'
      });
    }
  }
}

function anchorCurrent(id, anchorEls) {
  anchorEls.forEach(anchorEl => {
    if (anchorEl.dataset.anchor == id) {
      helpers.removeCurrentClass(anchorEls);
      anchorEl.classList.add('current');
    }
  });
}

function anchorScroll() {
  let anchorEls = document.querySelectorAll('.jsAnchor'),
    anchorTargetEs = [];
  if (anchorEls.length > 0) {
    anchorEls.forEach(anchorEl => {
      anchorTargetEs.push(document.getElementById(anchorEl.dataset.anchor));
    });
    anchorTargetEs.forEach(anchorTargetEl => {
      if (window.pageYOffset > anchorTargetEl.offsetTop - 70 && window.pageYOffset <= anchorTargetEl.offsetTop + anchorTargetEl.offsetHeight - 70) {
        anchorCurrent(anchorTargetEl.id, anchorEls);
      }
    });
  }
}

let toTopEl = document.getElementById('jsToTop'),
  scrollEl = document.getElementById('jsScroll'),
  headerEl = document.getElementById('jsHeader'),
  timerResize,
  timerScroll;
window.addEventListener('load', function() {
  addLiveLoad();
  toTopEl = document.getElementById('jsToTop'),
    scrollEl = document.getElementById('jsScroll'),
    headerEl = document.getElementById('jsHeader');
  toTop();
  helpers.showWhenScroll(toTopEl, 100);
  headerSticky();
  nav();
  anchor();
  anchorHash();
  navAnchor();
  expandNav();
});

function timeoutResize() {}
window.addEventListener('resize', function() {
  clearTimeout(timerResize);
  timerResize = setTimeout(timeoutResize, 300);
});

function timeoutScroll() {
  helpers.showWhenScroll(scrollEl, 100);
  helpers.showWhenScroll(toTopEl, 100);
  anchorScroll();
}
window.addEventListener('scroll', function() {
  clearTimeout(timerScroll);
  timerScroll = setTimeout(timeoutScroll, 100);
  headerSticky();
});